export default __webpack_public_path__ + "assets/images/f226d7ac00844c42c308a759922c4186.svg";